//test
export const increment = ({commit}) => {
    commit('INCREMENT')
}
export const decrement = ({commit}) => {
    commit('DECREMENT')
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js